'use strict';

function ChartLoader() {
  this.id = null;
  this.node = null;
  this.$node = null;
  this.extends = [];
  this.declaredClass = null;
  this.myLineChart = null;

  this.isValidDataToChart = true;

  this.init = function () {};

  this.preInitChartJS = function () {};

  this.initAllReady = function () {
    this.preInitChartJS();

    if (this.isValidDataToChart) {
      this.initChartJS();
    } else {
      console.error('MonthlyCreditScoreGraph: No valid scores to chart');
    }
  };

  this.initChartJS = function () {
    // Load Chart.js library and initialize
    if (typeof Chart === 'undefined') {
      // console.info("Loading Chart.min.js for the first time...");
      this._chartRequest = $.ajax({
        url: '/member/assets/javascripts/Chart.min.js',
        dataType: 'script',
        cache: true
      }).done($.proxy(function () {
        this.loadChart();
      }, this));
    } else {
      // console.info("Already loaded Chart.min.js.");
      this.loadChart();
    }
  };

  this.loadChart = function () {
    this._setupPlugins();

    var ctx = this.node.getContext('2d');

    var data = {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [{
        label: 'My First dataset',
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: 'rgba(75,192,192,1)',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(75,192,192,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(75,192,192,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: [65, 59, 80, 81, 56, 55, 40],
        spanGaps: false
      }]
    };

    var options = {
      defaultFontFamily: 'ProximaNova',
      defaultFontSize: 12,
      responsive: true,
      maintainAspectRatio: true
    };

    this.myLineChart = new Chart(this.node, {
      type: 'line',
      data: data,
      options: options
    });
  };

  this._setupPlugins = function () {};

  this.destroy = function () {
    if (this._chartRequest) {
      this._chartRequest.abort();
    }

    // If loaded
    if (this.myLineChart) {
      this.myLineChart.destroy();
    }
  };
}